// Quick add to cart from search results in prioritised mode (QA-001..007).

// How a product was added, sent as `mode` on the product-added-mode event so
// analytics can compare quick add with the normal product-page add.
export const PRODUCT_ADD_MODES = {
  // The Add button on a linked search card.
  quickAdd: 'quick_add',
  // Add / Update on a product page.
  standard: 'standard',
} as const

export type ProductAddMode = (typeof PRODUCT_ADD_MODES)[keyof typeof PRODUCT_ADD_MODES]

// Most units one cart line may hold. Must match MAX_ORDER_QUANTITY in the
// backend cart (add-to-cart rejects a line above it).
export const MAX_CART_LINE_QUANTITY = 99999

// Query parameter a linked search card adds when it opens the supplier
// product page: the collection / delivery choice made on the card (QA-001
// AC6). Only that link sets it, so every other way into the page is unchanged.
export const QUICK_ADD_METHOD_PARAM = 'method'
